import React, { useState } from 'react';
import { Card, Button, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PutObject from '../../lib/putObject';
import ImageUpload from '../../components/imageUpload';

const NotificationEditModal = ({ recordId, closeMainModal, reload }) => {
  const { data, loading, handleChange } = useFetch(`notifications/${recordId}`);
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');
  const [imageChange, setImageChange] = useState(null);

  const validateForm = () => {
    if (!data?.title) {
      setError('Please enter notification title');
      return false;
    }
    if (!data?.body) {
      setError('Please enter notification body');
      return false;
    }
    return true;
  };

  const saveEdit = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);

      const editedNotification = {
        _id: recordId,
        title: data.title,
        body: data.body,
      };

      if (imageChange !== null) {
        editedNotification.image = imageChange;
      }

      await PutObject('notifications', editedNotification);

      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to update notification. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>Edit Notification</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={closeMainModal} />
          </Card.Options>
        </Card.Header>
        {!loading && data && (
          <>
            <Card.Body>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form onSubmit={(e) => { e.preventDefault(); saveEdit(); }}>
                <Form.Input
                  name='title'
                  label='Title'
                  placeholder='Enter notification title'
                  value={data['title'] || ''}
                  onChange={handleChange}
                  required
                />

                <Form.Textarea
                  name='body'
                  label='Body'
                  placeholder='Enter notification body/content'
                  value={data['body'] || ''}
                  onChange={handleChange}
                  required
                  rows={4}
                />

                <ImageUpload
                  label="Notification Image"
                  initialUrl={data?.image}
                  uploadText="Click here to upload notification image"
                  alt="Notification Preview"
                  onChange={(value) => setImageChange(value)}
                />
              </Form>
            </Card.Body>
            <Card.Footer>
              <div style={{ textAlign: 'right' }}>
                <Button
                  color="primary"
                  size="sm"
                  className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
                  onClick={saveEdit}
                  disabled={saveLoading}
                >
                  Save Changes
                </Button>
                <Button
                  color="secondary"
                  size="sm"
                  className="ml-2"
                  onClick={closeMainModal}
                  disabled={saveLoading}
                >
                  Cancel
                </Button>
              </div>
            </Card.Footer>
          </>
        )}
      </Dimmer>
    </Card>
  );
};

export default NotificationEditModal;
